// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour l'icône animée avec flèche tournante */
.spinning_arrow_notificationIcon__NYo3A {
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_small__ivdS3 {
  width: 40px;
  height: 40px;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_large__cPIrj {
  width: 60px;
  height: 60px;
}

.spinning_arrow_logoImage__IguOY {
  width: 40px;
  height: 40px;
  position: relative;
  z-index: 2;
  border-radius: 50%;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_small__ivdS3 .spinning_arrow_logoImage__IguOY {
  width: 32px;
  height: 32px;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_large__cPIrj .spinning_arrow_logoImage__IguOY {
  width: 48px;
  height: 48px;
}

.spinning_arrow_spinningCircle__XONXB {
  position: absolute;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: spinning_arrow_spin__z-jzv 1.5s linear infinite;
  z-index: 1;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_small__ivdS3 .spinning_arrow_spinningCircle__XONXB {
  width: 48px;
  height: 48px;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_large__cPIrj .spinning_arrow_spinningCircle__XONXB {
  width: 72px;
  height: 72px;
}

.spinning_arrow_circleIcon__q6DmY {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_small__ivdS3 .spinning_arrow_circleIcon__q6DmY {
  width: 32px;
  height: 32px;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_large__cPIrj .spinning_arrow_circleIcon__q6DmY {
  width: 48px;
  height: 48px;
}

@keyframes spinning_arrow_spin__z-jzv {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spinning_arrow_iconBadge__YZhLU {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff5252;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 3;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_small__ivdS3 .spinning_arrow_iconBadge__YZhLU {
  width: 16px;
  height: 16px;
  font-size: 10px;
  top: -3px;
  right: -3px;
}

.spinning_arrow_notificationIcon__NYo3A.spinning_arrow_large__cPIrj .spinning_arrow_iconBadge__YZhLU {
  width: 24px;
  height: 24px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/shop/components/loaders/spinning_arrow.module.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* Styles pour l'icône animée avec flèche tournante */\n.notificationIcon {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.notificationIcon.small {\n  width: 40px;\n  height: 40px;\n}\n\n.notificationIcon.large {\n  width: 60px;\n  height: 60px;\n}\n\n.logoImage {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  z-index: 2;\n  border-radius: 50%;\n}\n\n.notificationIcon.small .logoImage {\n  width: 32px;\n  height: 32px;\n}\n\n.notificationIcon.large .logoImage {\n  width: 48px;\n  height: 48px;\n}\n\n.spinningCircle {\n  position: absolute;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: spin 1.5s linear infinite;\n  z-index: 1;\n}\n\n.notificationIcon.small .spinningCircle {\n  width: 48px;\n  height: 48px;\n}\n\n.notificationIcon.large .spinningCircle {\n  width: 72px;\n  height: 72px;\n}\n\n.circleIcon {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n.notificationIcon.small .circleIcon {\n  width: 32px;\n  height: 32px;\n}\n\n.notificationIcon.large .circleIcon {\n  width: 48px;\n  height: 48px;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.iconBadge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: #ff5252;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  z-index: 3;\n}\n\n.notificationIcon.small .iconBadge {\n  width: 16px;\n  height: 16px;\n  font-size: 10px;\n  top: -3px;\n  right: -3px;\n}\n\n.notificationIcon.large .iconBadge {\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationIcon": `spinning_arrow_notificationIcon__NYo3A`,
	"small": `spinning_arrow_small__ivdS3`,
	"large": `spinning_arrow_large__cPIrj`,
	"logoImage": `spinning_arrow_logoImage__IguOY`,
	"spinningCircle": `spinning_arrow_spinningCircle__XONXB`,
	"spin": `spinning_arrow_spin__z-jzv`,
	"circleIcon": `spinning_arrow_circleIcon__q6DmY`,
	"iconBadge": `spinning_arrow_iconBadge__YZhLU`
};
export default ___CSS_LOADER_EXPORT___;
